import { prebidStore } from "@/store/prebidStore";
import type { OzoneModule } from "@/ts/module";
import { getGoogleTag } from "@/utils/googletag";
export class Ozone implements OzoneModule {
    name = "Ozone" as const;
    async init(): Promise<void> {
        let testgroup: string;
        const gt = getGoogleTag();
        gt.cmd.push(() => {
            const storedTestGroup = gt.pubads().getTargeting("testgroup")[0];
            if (storedTestGroup) {
                testgroup = storedTestGroup;
            }
            else {
                testgroup = String(Math.floor(99 * Math.random()) + 1);
                gt.pubads().setTargeting("testgroup", testgroup);
            }
            const { actions } = prebidStore.getState();
            actions.setOzoneTestGroup(testgroup);
        });
    }
}
